import Router from '@/router';
import App from '@/utils/app';
import { isApp, isWxMiniProgram, checkUndefined } from '@/utils/api';

const getSafeUrl = url => {
	try {
		// 尝试创建 URL 对象
		new URL(url);
		return url;
	} catch (e) {
		// 如果创建失败，假设默认使用 https，这能兼容大多数的链接配置场景
		const fullUrl = `https://${url}`;
		return fullUrl;
	}
};

/**
 * 跳转代理
 *
 * 关于 iframe 的使用，主要是为了更方便保留页面状态；小程序端/App端不需要，主要是H5端
 * 对于文档和内部路由，并不需要考虑访问限制；访问限制主要来自于微信公众号 —— 即网址跳转
 * 这里的小程序判断，实际上只是进门小程序，并不包含三方渠道小程序
 *
 * @param {*} options
 * @returns
 */
export const proxyNavigateTo = options => {
	const { file, path, selfPath, name, query, minPath, title } = options;
	// 由于在三方渠道小程序是通过叠加webview进行跳转的
	// 所以是不同窗口的场景，不能用sessionStorage
	const comein_channel = localStorage.getItem('channel');
	const isThirdMiniProgram = isWxMiniProgram && !checkUndefined(comein_channel);

	// 文件预览跳转 —— 文档预览
	if (file) {
		if (isApp) {
			// 客户端
			App.openURL({
				url: file
			});
		} else if (isThirdMiniProgram) {
			//映恩生物小程序特殊处理
			if (comein_channel === 'duality') {
				// 跳转到 pdfview 页面，带上 file 和 path 参数
				navigateToPdfview(file, minPath, title);
				return;
			}
			window.location.href = file;
		} else if (isWxMiniProgram) {
			wx.miniProgram.navigateTo({
				url: '/pages/empty/empty?webSrc=' + encodeURIComponent(file)
			});
		} else {
			// window.open(file); //因为有些预览中间加了接口去换源，在手机端和微信和手机浏览器都打不开，先改为window.location.href
			window.location.href = file;
		}
		return;
	}

	// 网址跳转 —— mobile/配置链接/微信公众号文章
	if (path) {
		// 兼容 www 开头的无协议地址
		const appendedPath = getSafeUrl(path);
		if (isApp) {
			// 客户端
			App.openURL({
				url: appendedPath
			});
		} else if (isThirdMiniProgram) {
			const includesMobile = appendedPath.includes('comein.cn/mobile');
			if (includesMobile) {
				const baseUrl = location.origin;
				const miniappUrl = appendedPath.replace(baseUrl, '');
				wx.miniProgram.navigateTo({
					url: '/pages/index/index?url=' + encodeURIComponent(miniappUrl)
				});
			} else {
				window.location.href = appendedPath;
			}
		} else if (isWxMiniProgram) {
			wx.miniProgram.navigateTo({
				url: '/pages/empty/empty?webSrc=' + encodeURIComponent(appendedPath)
			});
		} else {
			window.open(appendedPath);
		}
		return;
	}

	// 内部路由跳转 —— irm-mobile
	if (name || selfPath) {
		const composeObj = selfPath
			? {
				path: selfPath,
				query
			}
			: {
				name,
				query
			};
		const getUrlHref = Router.resolve(composeObj).href;

		if (isThirdMiniProgram) {
			// 三方小程序 会主动拼接域名
			wx.miniProgram.navigateTo({
				url: '/pages/index/index?url=' + encodeURIComponent(getUrlHref)
			});
		} else if (isWxMiniProgram) {
			const fullPath = `${location.origin}${getUrlHref}`;
			wx.miniProgram.navigateTo({
				url: '/pages/empty/empty?webSrc=' + encodeURIComponent(fullPath)
			});
		} else {
			Router.push(composeObj);
		}

		return;
	}
};


// 映恩生物小程序特殊处理
const navigateToPdfview = (file, path, title) => {
	if (!file) return;
	Router.push({
		name: 'pdfview',
		query: {
			file: file ? encodeURIComponent(file) : '',
			path: path ? encodeURIComponent(path) : '',
			title: title ? encodeURIComponent(title) : ''
		}
	});
};